module.exports = __webpack_public_path__ + "static/media/bullet_icon.44558941.svg";